import { addMessages } from '@hana/i18n';

// Khoá chuỗi spy.* — mã nghiệp vụ không dịch.
addMessages('vi', {
  'spy.1': "Tỷ giá",
  'spy.2': "Lịch chi theo hạn",
  'spy.3': "Chờ chi theo đối tác",
  'spy.4': "Đề xuất đợt chi · thứ Sáu 23/Oct",
  'spy.5': "Xác nhận TK nhận",
  'spy.6': "Chứng từ",
  'spy.7': "Mã",
  'spy.8': "Loại",
  'spy.9': "Hạn · trạng thái",
  'spy.10': "Số tiền",
  'spy.11': "Đóng phải trả",
  'spy.12': "Triệu ₫",
  'spy.13': "Thu hộ cần chuyển trả",
  'spy.14': "Đưa khoản đến hạn vào đợt chi",
  'spy.15': "Đối tác",
  'spy.16': "Khoản",
  'spy.17': "Hạn chuyển trả",
  'spy.18': "Trạng thái",
});
addMessages('en', {
  'spy.1': "FX rate",
  'spy.2': "Payment schedule by due date",
  'spy.3': "Pending payment by partner",
  'spy.4': "Proposed payment run · Fri 23/Oct",
  'spy.5': "Confirm receiving account",
  'spy.6': "Documents",
  'spy.7': "Code",
  'spy.8': "Type",
  'spy.9': "Due · status",
  'spy.10': "Amount",
  'spy.11': "Close payable",
  'spy.12': "Million ₫",
  'spy.13': "Collected-on-behalf to remit",
  'spy.14': "Add due items to payment run",
  'spy.15': "Partner",
  'spy.16': "Item",
  'spy.17': "Remit due",
  'spy.18': "Status",
});
